const MST_TIME_ZONE = "America/Phoenix";

export const formatTimeMst = (dateLike: Date | string) => {
  const date = dateLike instanceof Date ? dateLike : new Date(dateLike);

  return date.toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
    timeZone: MST_TIME_ZONE,
  });
};

export const formatDateMst = (dateLike: Date | string) => {
  const date = dateLike instanceof Date ? dateLike : new Date(dateLike);

  return date.toLocaleDateString("en-US", {
    weekday: "long",
    month: "long",
    day: "numeric",
    timeZone: MST_TIME_ZONE,
  });
};

export const mstDateKey = (dateLike: Date | string) => {
  const date = dateLike instanceof Date ? dateLike : new Date(dateLike);

  // Stable YYYY-MM-DD key in MST to compare "same day"
  return date.toLocaleDateString("en-CA", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    timeZone: MST_TIME_ZONE,
  });
};
